import { indianStates } from "../constants/indianStates";
import { countryCodes } from "../constants/countryCodes";

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const mobileRegex = /^\d{10}$/;
const postalCodeRegex = /^\d{6}$/;

const required = (value) => String(value || "").trim().length > 0;

export const validateProfileForm = (form) => {
  const errors = {};

  if (!required(form.firstName)) {
    errors.firstName = "First name is required";
  }

  if (!required(form.lastName)) {
    errors.lastName = "Last name is required";
  }

  if (!required(form.mobile)) {
    errors.mobile = "Mobile number is required";
  } else if (!mobileRegex.test(String(form.mobile).trim())) {
    errors.mobile = "Enter exactly 10 digits";
  }

  if (!required(form.mobileCountryCode)) {
    errors.mobileCountryCode = "Country code is required";
  } else if (!countryCodes.some((country) => country.code === form.mobileCountryCode)) {
    errors.mobileCountryCode = "Select a valid country code";
  }

  if (!required(form.address)) {
    errors.address = "Address is required";
  }

  if (!required(form.city)) {
    errors.city = "City is required";
  }

  if (!required(form.state)) {
    errors.state = "State is required";
  } else if (!indianStates.includes(form.state)) {
    errors.state = "Select a valid state";
  }

  if (!required(form.postalCode)) {
    errors.postalCode = "Postal code is required";
  } else if (!postalCodeRegex.test(String(form.postalCode).trim())) {
    errors.postalCode = "Enter a valid 6-digit postal code";
  }

  return errors;
};

export const validateSignupForm = (form) => {
  const errors = validateProfileForm(form);

  if (!required(form.email)) {
    errors.email = "Email is required";
  } else if (!emailRegex.test(String(form.email).trim())) {
    errors.email = "Enter a valid email address";
  }

  if (!required(form.password)) {
    errors.password = "Password is required";
  } else if (String(form.password).length < 6) {
    errors.password = "Password must be at least 6 characters";
  }

  if (!required(form.confirmPassword)) {
    errors.confirmPassword = "Confirm password is required";
  } else if (form.password !== form.confirmPassword) {
    errors.confirmPassword = "Passwords do not match";
  }

  return errors;
};

export const hasValidationErrors = (errors) => Object.keys(errors).length > 0;
